import { I18n } from 'react-redux-i18n';

import { Ellipsis } from '@common/components/Ellipsis';
import { Flex } from '@common/components/Flex';
import { MODULE_NAME } from '@modules/audit-report';
import { getTestAttributes } from '@common/utils/tests';
import { Checkbox } from '@common/components/checkbox';

import './field-selector-trigger.styles.scss';

export const FieldSelectorTrigger = (props) => {
  const { 
    contextType,
    indicator, 
    name,
    use,
    imageURL,
    fieldId,
    onOpenSelector,
    onUseChange,
  } = props;

  return (
    <Flex alignItems="center" justify="space-between" className="FieldAuditReportUpdates__selector">
      <Checkbox
        {...getTestAttributes(MODULE_NAME, 'filters-use', 'checkbox', contextType)} 
        data-type={contextType} 
        checked={use} 
        className="FieldAuditReportUpdates__selector__checkbox" 
        onChange={onUseChange}
      >
        {I18n.t(indicator)}
      </Checkbox>
      <Flex alignItems="center" className={use ? undefined : 'FieldAuditReportUpdates__selector__controls--disabled'}>
        <span className="FieldAuditReportUpdates__selector__label">{I18n.t('Item Name:')}</span>
        <Flex alignItems="center">
          <Flex className="FieldAuditReportUpdates__selector__value">
            <img {...getTestAttributes(MODULE_NAME, 'filters-field', 'img', `${contextType}-${fieldId}`)} src={imageURL} width={20} />
            <Ellipsis 
              {...getTestAttributes(MODULE_NAME, 'filters-field', 'name', `${contextType}-${fieldId}`)} 
              width={284} 
              className="FieldAuditReportUpdates__selector__value__text" 
              text={name} 
            />
          </Flex>
          <button 
            {...getTestAttributes(MODULE_NAME, 'filters-field-selector-trigger', 'btn', contextType)} 
            disabled={!use} 
            className="FieldAuditReportUpdates__selector__open-btn" 
            onClick={onOpenSelector}
          >
            <i className="fa fa-edit" />
          </button>
        </Flex>
      </Flex>
    </Flex>
  );
};